import { render, staticRenderFns } from "./TableFooter.vue?vue&type=template&id=5de7d178&scoped=true&v-slot%3Afooter=true"
import script from "./TableFooter.vue?vue&type=script&lang=js"
export * from "./TableFooter.vue?vue&type=script&lang=js"
import style0 from "./TableFooter.vue?vue&type=style&index=0&id=5de7d178&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de7d178",
  null
  
)

export default component.exports